export const GET_GROUP_MANAGEMENT_TABLE = "GET_GROUP_MANAGEMENT_TABLE";
export const CREATE_UPDATE_DELETE_GROUP_LOADING = "CREATE_UPDATE_DELETE_GROUP_LOADING";
export const GET_USERS_NOT_IN_GROUP = "GET_USERS_NOT_IN_GROUP";